var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9C3.067 9 1.5 10.567 1.5 12.5C1.5 14.433 3.067 16 5 16H12C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9H5ZM12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15Z",
    fill: "#4559A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1C3.61929 1 2.5 2.11929 2.5 3.5C2.5 4.88071 3.61929 6 5 6C6.38071 6 7.5 4.88071 7.5 3.5C7.5 2.11929 6.38071 1 5 1ZM7.44949 1C8.09777 1.63526 8.5 2.52066 8.5 3.5C8.5 4.47934 8.09777 5.36474 7.44949 6H12C13.3807 6 14.5 4.88071 14.5 3.5C14.5 2.11929 13.3807 1 12 1H7.44949ZM5 0H12C13.933 0 15.5 1.567 15.5 3.5C15.5 5.433 13.933 7 12 7H5C3.067 7 1.5 5.433 1.5 3.5C1.5 1.567 3.067 0 5 0Z",
    fill: "#4559A7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSwitch);
export default __webpack_public_path__ + "static/media/double-switch.7b7f43f4b90e960728963f74d03f347a.svg";
export { ForwardRef as ReactComponent };